import { Navigate } from "react-router-dom";
import { useAuth } from "../services/authService";
import {
  normalizeStatus,
  normalizeRole,
  canManageFirmware,
} from "../services/authz";

export default function ServiceAdminRoute({ children }) {
  const { currentUser, userStatus, userRole } = useAuth();

  if (!currentUser) return <Navigate to="/login" replace />;

  const status = normalizeStatus(userStatus);
  const role = normalizeRole(userRole);

  const allowed = canManageFirmware(status, role); // super_admin + service_admin
  if (!allowed) return <Navigate to="/firmware" replace />;

  return children;
}
